import { ChangeDetectionStrategy, Component, input, output, signal } from '@angular/core';
import { IconUIComponent } from '../../../atoms/icon/icon.component';
import { FiltersButtonUIComponent } from '../../../atoms/filters-button/filters-button.component';
import { TranslatePipe } from '@ngx-translate/core';

// TODO: delete old translate from i18n
@Component({
  selector: 'fr8bot-ui-smart-filter',
  templateUrl: './smart-filter.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconUIComponent, FiltersButtonUIComponent, TranslatePipe],
})
export class SmartFilterUIComponent {
  filtersCount = input(0);
  disablePanel = input(false);

  clearFilters = output();

  private readonly open = signal(false);
  readonly isOpen = this.open.asReadonly();

  toggleFilters() {
    this.open.update((state) => !state);
  }
}
